export default __webpack_public_path__ + "static/media/instructor-4.adfbe0b6.webp";